import styles from '@/styles/forms.module.scss';

/** ProgressIndicator — три точки с анимацией (экран менеджера) */
export default function ProgressIndicator({ activeIndex }) {
  return (
    <div className={styles.progressDots}>
      {[0, 1, 2].map(i => (
        <div
          key={i}
          className={[styles.progressDot, i === activeIndex ? styles.active : ''].join(' ')}
        />
      ))}
    </div>
  );
}
